"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoHookParamsError = void 0;
var common_core_1 = require("moralis/common-core");
var NoHookParamsError = /** @class */ (function (_super) {
    __extends(NoHookParamsError, _super);
    function NoHookParamsError(hookName) {
        return _super.call(this, {
            code: common_core_1.CoreErrorCode.GENERIC_CORE_ERROR,
            message: "No params provided for the ".concat(hookName, "() hook. Please check the Hook Usage Examples guide https://github.com/MoralisWeb3/Moralis-JS-SDK/tree/main/packages/next#-hook-usage-example"),
        }) || this;
    }
    return NoHookParamsError;
}(common_core_1.MoralisError));
exports.NoHookParamsError = NoHookParamsError;
//# sourceMappingURL=errors.js.map